<template>
    <a class="order-link" :href="order.url">
        <img src="../assets/icons/order.png">
        <div class="title">{{order.name}}</div>
        <div class="text">{{order.description}}</div>
    </a>
</template>

<script>
    export default {
        props: ['order'],
        name: "OrderLink",
    }
</script>

<style scoped>
    a{
        text-decoration: none;

        text-align: center;
        max-width: 360px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 20px 20px
    }

    a img{
        width: 100px;
        height: 100px;
        margin-bottom: 14px;
    }

    a .title{
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 25px;
        margin-top: 18px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
    }

    a .text{
        font-size: 16px;
        line-height: 25px;
        padding:  0 20px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 400;
        color: #000;
    }


</style>